import httpManager from "../axios/httpManager";

export function getMainStatistic(partner, begin, end, smonth,type) {
    return httpManager.post('/statistic/main_statistic?begin=' + begin + '&end=' + end + '&smonth=' + smonth+ '&type=' + type + '&t=' + new Date().getTime(), partner)
}
